import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["glow"]
  
  connect() {
    if (window.matchMedia("(hover: hover)").matches) {
      this.element.addEventListener("mousemove", this.handleMove.bind(this))
      this.element.addEventListener("mouseleave", this.handleLeave.bind(this))
    }
  }
  
  handleMove(event) {
    const rect = this.element.getBoundingClientRect()
    const x = event.clientX - rect.left
    const y = event.clientY - rect.top
    
    this.element.style.setProperty("--mouse-x", `${x}px`)
    this.element.style.setProperty("--mouse-y", `${y}px`)
    
    if (this.hasGlowTarget) {
      this.glowTarget.style.opacity = "1"
      this.glowTarget.style.background = `radial-gradient(180px circle at ${x}px ${y}px, rgba(80, 177, 253, 0.15), transparent)`
    }
  }
  
  handleLeave() {
    if (this.hasGlowTarget) {
      this.glowTarget.style.opacity = "0"
    }
  }
}
